/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_CoverInputs */

const cs_enum_cover = /** @type {(inputs: Enum_CoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Úvodní`)
};

const en_enum_cover = /** @type {(inputs: Enum_CoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cover`)
};

/**
* | output |
* | --- |
* | "Cover" |
*
* @param {Enum_CoverInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_cover = /** @type {((inputs?: Enum_CoverInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_CoverInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_cover(inputs)
	return cs_enum_cover(inputs)
});